import { getUa, isIOS, isSayWeeeApp } from '@/utils/common/device';
/**
 * 獲取app的版本
 * @param ctx
 * @returns
 */
export const getAppVersion = (ctx?): string => {
  const ua = getUa(ctx);
  const appVersion = (ua?.match(/(?:weeeapp|masgustoapp)\s([\d.]+)/i)?.[1] || '').trim() || '';
  return appVersion.split('.').slice(0, -1).join('.') || '';
};

export const getAppVersionNum = (ctx?) => {
  const ua = getUa(ctx);
  const version = ua?.match(/(?:weeeapp|masgustoapp)\s([\d.]+)/i)?.[1];
  const [majorVersion = 0, minorVersion = 0, minVersion = 0] = (version || '').trim().split('.');

  return {
    majorVersion: +majorVersion,
    minorVersion: +minorVersion,
    minVersion: +minVersion
  };
};

/**
 *
 * @param version 当前版本是否大于或者等于传入的版本
 * @param ctx
 */
export const isAboveVersion = (version: string, ctx?): boolean => {
  const { majorVersion, minorVersion, minVersion } = getAppVersionNum(ctx);

  const [comparedMajorVersion = 0, comparedMinorVersion = 0, comparedMinVersion = 0] = (version || '').split('.');
  if (majorVersion > +comparedMajorVersion) {
    return true;
  }
  if (majorVersion === +comparedMajorVersion && minorVersion > +comparedMinorVersion) {
    return true;
  }
  if (
    majorVersion === +comparedMajorVersion &&
    minorVersion === +comparedMinorVersion &&
    minVersion >= +comparedMinVersion
  ) {
    return true;
  }
  return false;
};

/**
 * 对比两个平台的代码,如果平台是H5，返回false
 * @param versions 两个平台分别的版本，数组的第一项是ios的版本 第二项是android的版本
 * @param ctx
 * @returns
 */
export const isAboveVersions = (versions: string[], ctx?) => {
  const isIos = isIOS(ctx);
  const paltformConditions = [isIos, !isIos];
  if (!isSayWeeeApp(ctx)) {
    return false;
  }
  const result = versions.some((platformVersion, index) => {
    return paltformConditions[index] && isAboveVersion(platformVersion, ctx);
  });
  return result;
};
